// extracted by mini-css-extract-plugin
export var backButton = "_j-1";
export var content = "_j-d";
export var continueButton = "_j-7";
export var continueHint = "_j-8";
export var continueRow = "_j-6";
export var leftInner = "_j-0";
export var sidebarContent = "_j-5";
export var skipButton = "_j-c";
export var spacer = "_j-2";
export var spin = "_j-a";
export var spinner = "_j-9";
export var spinnerOverlay = "_j-b";
export var subtitle = "_j-4";
export var title = "_j-3";